import _ from 'lodash';
window._ = _;

import 'bootstrap';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import '@zachleat/table-saw';
import Alpine from 'alpinejs';
window.Alpine = Alpine;

window.bootstrap = require('bootstrap');
Alpine.start();

const CLASS_NAME = 'has-child-dropdown-show';

document.querySelectorAll('.dropdown').forEach(function(dd) {
    dd.addEventListener('hide.bs.dropdown', function(e) {
        if (this.classList.contains(CLASS_NAME)) {
            this.classList.remove(CLASS_NAME);
            e.preventDefault();
        }
        e.stopPropagation(); // do not need pop in multi level mode
    });
});

Livewire.on('scrollTop', () => {
    const formErrors = document.querySelector("#form-errors");
    if (formErrors) {
        const offset = formErrors.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: offset,
            left: 15,
            behavior: 'smooth'
        });
    }
});

Livewire.on('reportEmailSent', () => {
    const systemModal = document.querySelector('#view-quote-media-decision-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('documentReviewed', () => {
    const systemModal = document.querySelector('#view-quote-media-decision-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('quotePricingUpating', () => {
    const systemModal = document.querySelector('#quote-pricing-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientStyleDiscountCreated', () => {
    const systemModal = document.querySelector('#create-client-style-discount-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientStyleDiscountUpdated', () => {
    const systemModal = document.querySelector('#update-client-style-discount-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientStyleDiscountDeleted', () => {
    const systemModal = document.querySelector('#delete-client-style-discount-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('manufacturerAlertDeleted', () => {
    const systemModal = document.querySelector('#delete-manufacturer-alert-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('quoteAlertDeleted', () => {
    const systemModal = document.querySelector('#delete-quote-alert-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientProductStyleDiscountDeleted', () => {
    const systemModal = document.querySelector('#delete-client-style-discount-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientProductStyleDiscountCreated', () => {
    const systemModal = document.querySelector('#create-client-style-discount-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientProductStyleDiscountUpdated', () => {
    const systemModal = document.querySelector('#update-client-style-discount-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('titleDeleted', () => {
    const systemModal = document.querySelector('#delete-title-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('lockTypeSashCheckDeleted', () => {
    const systemModal = document.querySelector('#delete-lock-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('lockTypeSashCheckUpdated', () => {
    const systemModal = document.querySelector('#update-lock-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('lockTypeSashCheckCreated', () => {
    const systemModal = document.querySelector('#create-lock-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('hingeTypeSashCheckDeleted', () => {
    const systemModal = document.querySelector('#delete-hinge-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('hingeTypeSashCheckUpdated', () => {
    const systemModal = document.querySelector('#update-hinge-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('hingeTypeSashCheckCreated', () => {
    const systemModal = document.querySelector('#create-hinge-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('productStyleSashCheckDeleted', () => {
    const systemModal = document.querySelector('#delete-product-style-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('productStyleSashCheckUpdated', () => {
    const systemModal = document.querySelector('#update-product-style-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('productStyleSashCheckCreated', () => {
    const systemModal = document.querySelector('#create-product-style-sash-check-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('closeStylePickerModal', () => {
    const systemModal = document.querySelector('#style-picker-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('refreshCalendar', () => {
    const systemModal = document.querySelector('#diary-event-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.hide();
});

Livewire.on('paymentAdded', () => {
    const systemModal = document.querySelector('#quote-payment-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('paymentDeleted', () => {
    const systemModal = document.querySelector('#delete-payment-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('serviceCallDeleted', () => {
    const systemModal = document.querySelector('#delete-service-call-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('invoiceAdded', () => {
    const systemModal = document.querySelector('#quote-invoice-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('invoiceDeleted', () => {
    const systemModal = document.querySelector('#delete-invoice-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('clientDocumentDeleted', () => {
    const systemModal = document.querySelector('#delete-client-document-media-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('quoteMediaDeleted', () => {
    const systemModal = document.querySelector('#delete-quote-media-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('clientDocumentCategoryDeleted', () => {
    const systemModal = document.querySelector('#delete-client-document-media-category-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('userDeleted', () => {
    const userModal = document.querySelector('#delete-user-modal');
    const modal = bootstrap.Modal.getInstance(userModal);    
    modal.toggle();
});

Livewire.on('employeeDeleted', () => {
    const employeeModal = document.querySelector('#delete-employee-modal');
    const modal = bootstrap.Modal.getInstance(employeeModal);    
    modal.toggle();
});

Livewire.on('employeeRoleDeleted', () => {
    const employeeModal = document.querySelector('#delete-employee-role-modal');
    const modal = bootstrap.Modal.getInstance(employeeModal);    
    modal.toggle();
});

Livewire.on('manufacturerInviteDeleted', () => {
    const manufacturerInviteModal = document.querySelector('#delete-manufacturer-invite-modal');
    const modal = bootstrap.Modal.getInstance(manufacturerInviteModal);    
    modal.toggle();
});

Livewire.on('manufacturerDeleted', () => {
    const manufacturerModal = document.querySelector('#delete-manufacturer-modal');
    const modal = bootstrap.Modal.getInstance(manufacturerModal);    
    modal.toggle();
});

Livewire.on('clientInviteDeleted', () => {
    const clientInviteModal = document.querySelector('#delete-client-invite-modal');
    const modal = bootstrap.Modal.getInstance(clientInviteModal);    
    modal.toggle();
});


Livewire.on('addedCillVariation', () => {
    const systemModal = document.querySelector('#create-cill-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedCillVariation', () => {
    const systemModal = document.querySelector('#generate-cill-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('addedCompositeDoorVariation', () => {
    const systemModal = document.querySelector('#create-composite-door-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('generatedCompositeDoorVariation', () => {
    const systemModal = document.querySelector('#generate-composite-door-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedSpacerVariation', () => {
    const systemModal = document.querySelector('#create-spacer-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedSpacerVariation', () => {
    const systemModal = document.querySelector('#generate-spacer-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('addedFrameExtensionVariation', () => {
    const systemModal = document.querySelector('#create-frame-extension-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedFrameExtensionVariation', () => {
    const systemModal = document.querySelector('#generate-frame-extension-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedLetterboxVariation', () => {
    const systemModal = document.querySelector('#create-letterbox-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedLetterboxVariation', () => {
    const systemModal = document.querySelector('#generate-letterbox-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedSashVariation', () => {
    const systemModal = document.querySelector('#create-sash-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedSashVariation', () => {
    const systemModal = document.querySelector('#generate-sash-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedHandleVariation', () => {
    const systemModal = document.querySelector('#create-handle-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('generatedHandleVariation', () => {
    const systemModal = document.querySelector('#generate-handle-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedHingeVariation', () => {
    const systemModal = document.querySelector('#create-hinge-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('generatedHingeVariation', () => {
    const systemModal = document.querySelector('#generate-hinge-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedVentVariation', () => {
    const systemModal = document.querySelector('#create-vent-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedVentVariation', () => {
    const systemModal = document.querySelector('#generate-vent-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedOuterFrameVariation', () => {
    const systemModal = document.querySelector('#create-outer-frame-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedOuterFrameVariation', () => {
    const systemModal = document.querySelector('#generate-outer-frame-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('addedTransomMullionVariation', () => {
    const systemModal = document.querySelector('#create-transom-mullion-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('generatedTransomMullionVariation', () => {
    const systemModal = document.querySelector('#generate-transom-mullion-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});


Livewire.on('addedBayAngle', () => {
    const systemModal = document.querySelector('#create-bay-detail-angle-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('bayDetailPartAdded', () => {
    const systemModal = document.querySelector('#create-bay-detail-part-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('bayDetailPartUpdated', () => {
    const systemModal = document.querySelector('#update-bay-detail-part-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('bayDetailPartDeleted', () => {
    const systemModal = document.querySelector('#delete-bay-detail-part-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});



Livewire.on('clientDeleted', () => {
    const clientModal = document.querySelector('#delete-client-modal');
    const modal = bootstrap.Modal.getInstance(clientModal);    
    modal.toggle();
});

Livewire.on('productTypeDeleted', () => {
    const typeModal = document.querySelector('#delete-product-type-modal');
    const modal = bootstrap.Modal.getInstance(typeModal);    
    modal.toggle();
});

Livewire.on('productProfileDeleted', () => {
    const profileModal = document.querySelector('#delete-product-profile-modal');
    const modal = bootstrap.Modal.getInstance(profileModal);    
    modal.toggle();
});

Livewire.on('productStyleDeleted', () => {
    const styleModal = document.querySelector('#delete-product-style-modal');
    const modal = bootstrap.Modal.getInstance(styleModal);    
    modal.toggle();
});

Livewire.on('patioStyleDeleted', () => {
    const styleModal = document.querySelector('#delete-patio-style-modal');
    const modal = bootstrap.Modal.getInstance(styleModal);    
    modal.toggle();
});

Livewire.on('productSystemDeleted', () => {
    const systemModal = document.querySelector('#delete-product-system-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('quoteDeleted', () => {
    const systemModal = document.querySelector('#delete-quote-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('quoteDuplicated', () => {
    const systemModal = document.querySelector('#duplicate-quote-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('cillVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-cill-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('compositeDoorVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-composite-door-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('spacerVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-spacer-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('frameExtensionVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-frame-extension-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('letterboxVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-letterbox-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('sashVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-sash-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('handleVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-handle-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('hingeVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-hinge-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('ventVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-vent-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('outerFrameVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-outer-frame-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('transomMullionVariationDeleted', () => {
    const systemModal = document.querySelector('#delete-transom-mullion-variation-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});





Livewire.on('bayDetailAngleDeleted', () => {
    const systemModal = document.querySelector('#delete-bay-detail-angle-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('leadTimeDeleted', () => {
    const leadTimeModal = document.querySelector('#delete-lead-time-modal');
    const modal = bootstrap.Modal.getInstance(leadTimeModal);    
    modal.toggle();
});

Livewire.on('beadDeleted', () => {
    const beadModal = document.querySelector('#delete-bead-modal');
    const modal = bootstrap.Modal.getInstance(beadModal);    
    modal.toggle();
});

Livewire.on('cillDeleted', () => {
    const cillModal = document.querySelector('#delete-cill-modal');
    const modal = bootstrap.Modal.getInstance(cillModal);    
    modal.toggle();
});

Livewire.on('colourDeleted', () => {
    const colourModal = document.querySelector('#delete-colour-modal');
    const modal = bootstrap.Modal.getInstance(colourModal);    
    modal.toggle();
});

Livewire.on('colourGroupDeleted', () => {
    const colourGroupModal = document.querySelector('#delete-colour-group-modal');
    const modal = bootstrap.Modal.getInstance(colourGroupModal);    
    modal.toggle();
});

Livewire.on('colourTypeDeleted', () => {
    const colourTypeModal = document.querySelector('#delete-colour-type-modal');
    const modal = bootstrap.Modal.getInstance(colourTypeModal);    
    modal.toggle();
});

Livewire.on('customerDeleted', () => {
    const customerModal = document.querySelector('#delete-customer-modal');
    const modal = bootstrap.Modal.getInstance(customerModal);    
    modal.toggle();
});

Livewire.on('customerExtraDeleted', () => {
    const customerModal = document.querySelector('#delete-customer-extra-modal');
    const modal = bootstrap.Modal.getInstance(customerModal);    
    modal.toggle();
});
Livewire.on('customerExtraArchived', () => {
    const customerModal = document.querySelector('#archive-customer-extra-modal');
    const modal = bootstrap.Modal.getInstance(customerModal);    
    modal.toggle();
});

Livewire.on('drainageDeleted', () => {
    const drainageModal = document.querySelector('#delete-drainage-modal');
    const modal = bootstrap.Modal.getInstance(drainageModal);    
    modal.toggle();
});

Livewire.on('panelColourDeleted', () => {
    const colourModal = document.querySelector('#delete-panel-colour-modal');
    const modal = bootstrap.Modal.getInstance(colourModal);    
    modal.toggle();
});

Livewire.on('extraDeleted', () => {
    const extraModal = document.querySelector('#delete-extra-modal');
    const modal = bootstrap.Modal.getInstance(extraModal);    
    modal.toggle();
});

Livewire.on('finishDeleted', () => {
    const finishModal = document.querySelector('#delete-finish-modal');
    const modal = bootstrap.Modal.getInstance(finishModal);    
    modal.toggle();
});

Livewire.on('frameExtensionDeleted', () => {
    const frameExtensionModal = document.querySelector('#delete-frame-extension-modal');
    const modal = bootstrap.Modal.getInstance(frameExtensionModal);    
    modal.toggle();
});

Livewire.on('gasketDeleted', () => {
    const gasketModal = document.querySelector('#delete-gasket-modal');
    const modal = bootstrap.Modal.getInstance(gasketModal);    
    modal.toggle();
});

Livewire.on('glassDeleted', () => {
    const glassModal = document.querySelector('#delete-glass-modal');
    const modal = bootstrap.Modal.getInstance(glassModal);    
    modal.toggle();
});

Livewire.on('glassExtraDeleted', () => {
    const glassExtraModal = document.querySelector('#delete-glass-extra-modal');
    const modal = bootstrap.Modal.getInstance(glassExtraModal);    
    modal.toggle();
});

Livewire.on('glassPriceListDeleted', () => {
    const glassModal = document.querySelector('#delete-glass-price-list-modal');
    const modal = bootstrap.Modal.getInstance(glassModal);    
    modal.toggle();
});

Livewire.on('glassSelectionListDeleted', () => {
    const glassModal = document.querySelector('#delete-glass-selection-list-modal');
    const modal = bootstrap.Modal.getInstance(glassModal);    
    modal.toggle();
});

Livewire.on('glassExtraSelectionListDeleted', () => {
    const glassModal = document.querySelector('#delete-glass-extra-selection-list-modal');
    const modal = bootstrap.Modal.getInstance(glassModal);    
    modal.toggle();
});

Livewire.on('handleDeleted', () => {
    const handleModal = document.querySelector('#delete-handle-modal');
    const modal = bootstrap.Modal.getInstance(handleModal);    
    modal.toggle();
});

Livewire.on('hingeDeleted', () => {
    const hingeModal = document.querySelector('#delete-hinge-modal');
    const modal = bootstrap.Modal.getInstance(hingeModal);    
    modal.toggle();
});

Livewire.on('letterboxDeleted', () => {
    const letterboxModal = document.querySelector('#delete-letterbox-modal');
    const modal = bootstrap.Modal.getInstance(letterboxModal);    
    modal.toggle();
});

Livewire.on('locationDeleted', () => {
    const locationModal = document.querySelector('#delete-location-modal');
    const modal = bootstrap.Modal.getInstance(locationModal);    
    modal.toggle();
});

Livewire.on('lockDeleted', () => {
    const lockModal = document.querySelector('#delete-lock-modal');
    const modal = bootstrap.Modal.getInstance(lockModal);    
    modal.toggle();
});

Livewire.on('lowThresholdDeleted', () => {
    const lowThresholdModal = document.querySelector('#delete-low-threshold-modal');
    const modal = bootstrap.Modal.getInstance(lowThresholdModal);    
    modal.toggle();
});

Livewire.on('outerFrameDeleted', () => {
    const outerFrameModal = document.querySelector('#delete-outer-frame-modal');
    const modal = bootstrap.Modal.getInstance(outerFrameModal);    
    modal.toggle();
});

Livewire.on('productDeleted', () => {
    const productModal = document.querySelector('#delete-product-modal');
    const modal = bootstrap.Modal.getInstance(productModal);    
    modal.toggle();
});
Livewire.on('groupDeleted', () => {
    const groupModal = document.querySelector('#delete-group-modal');
    const modal = bootstrap.Modal.getInstance(groupModal);    
    modal.toggle();
});

Livewire.on('reinforcementDeleted', () => {
    const reinforcementModal = document.querySelector('#delete-reinforcement-modal');
    const modal = bootstrap.Modal.getInstance(reinforcementModal);    
    modal.toggle();
});

Livewire.on('sashDeleted', () => {
    const sashModal = document.querySelector('#delete-sash-modal');
    const modal = bootstrap.Modal.getInstance(sashModal);    
    modal.toggle();
});

Livewire.on('sashExtraDeleted', () => {
    const sashExtraModal = document.querySelector('#delete-sash-extra-modal');
    const modal = bootstrap.Modal.getInstance(sashExtraModal);    
    modal.toggle();
});

Livewire.on('spacerDeleted', () => {
    const spacerModal = document.querySelector('#delete-spacer-modal');
    const modal = bootstrap.Modal.getInstance(spacerModal);    
    modal.toggle();
});

Livewire.on('transomMullionDeleted', () => {
    const transomMullionModal = document.querySelector('#delete-transom-mullion-modal');
    const modal = bootstrap.Modal.getInstance(transomMullionModal);    
    modal.toggle();
});

Livewire.on('ventDeleted', () => {
    const ventModal = document.querySelector('#delete-vent-modal');
    const modal = bootstrap.Modal.getInstance(ventModal);    
    modal.toggle();
});

Livewire.on('weatherBarDeleted', () => {
    const weatherBarModal = document.querySelector('#delete-weather-bar-modal');
    const modal = bootstrap.Modal.getInstance(weatherBarModal);    
    modal.toggle();
});

Livewire.on('bayStyleDeleted', () => {
    const bayStyleModal = document.querySelector('#delete-bay-style-modal');
    const modal = bootstrap.Modal.getInstance(bayStyleModal);    
    modal.toggle();
});

Livewire.on('compositeDoorDeleted', () => {
    const compositeDoorModal = document.querySelector('#delete-composite-door-modal');
    const modal = bootstrap.Modal.getInstance(compositeDoorModal);    
    modal.toggle();
});

Livewire.on('compositeDoorGlassDeleted', () => {
    const compositeDoorGlassModal = document.querySelector('#delete-composite-door-glass-modal');
    const modal = bootstrap.Modal.getInstance(compositeDoorGlassModal);    
    modal.toggle();
});

Livewire.on('compositeDoorCassetteDeleted', () => {
    const compositeDoorCassetteModal = document.querySelector('#delete-composite-door-cassette-modal');
    const modal = bootstrap.Modal.getInstance(compositeDoorCassetteModal);    
    modal.toggle();
});

Livewire.on('conservatoryRoofDeleted', () => {
    const conservatoryRoofModal = document.querySelector('#delete-conservatory-roof-modal');
    const modal = bootstrap.Modal.getInstance(conservatoryRoofModal);    
    modal.toggle();
});

Livewire.on('conservatoryRoofManufacturerDeleted', () => {
    const conservatoryRoofModal = document.querySelector('#delete-conservatory-roof-manufacturer-modal');
    const modal = bootstrap.Modal.getInstance(conservatoryRoofModal);    
    modal.toggle();
});

Livewire.on('conservatoryRoofColourDeleted', () => {
    const conservatoryRoofColourModal = document.querySelector('#delete-conservatory-roof-colour-modal');
    const modal = bootstrap.Modal.getInstance(conservatoryRoofColourModal);    
    modal.toggle();
});

Livewire.on('conservatoryRoofExtraDeleted', () => {
    const conservatoryRoofExtraModal = document.querySelector('#delete-conservatory-roof-extra-modal');
    const modal = bootstrap.Modal.getInstance(conservatoryRoofExtraModal);    
    modal.toggle();
});

Livewire.on('handleTypeDeleted', () => {
    const systemModal = document.querySelector('#delete-handle-type-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('hingeTypeDeleted', () => {
    const systemModal = document.querySelector('#delete-hinge-type-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('lockTypeDeleted', () => {
    const systemModal = document.querySelector('#delete-lock-type-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('spacerTypeDeleted', () => {
    const systemModal = document.querySelector('#delete-spacer-type-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('ventTypeDeleted', () => {
    const systemModal = document.querySelector('#delete-vent-type-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('priceListDeleted', () => {
    const systemModal = document.querySelector('#delete-price-list-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('vatRateDeleted', () => {
    const systemModal = document.querySelector('#delete-vat-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('contractStatusDeleted', () => {
    const systemModal = document.querySelector('#delete-contract-status-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('orderStatusDeleted', () => {
    const systemModal = document.querySelector('#delete-order-status-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('orderDeleted', () => {
    const systemModal = document.querySelector('#delete-order-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('orderExtraDeleted', () => {
    const systemModal = document.querySelector('#delete-extra-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('orderFrameDeleted', () => {
    const systemModal = document.querySelector('#delete-frame-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('frameDeleted', () => {
    const systemModal = document.querySelector('#delete-frame-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('frameCopied', () => {
    const systemModal = document.querySelector('#copy-frame-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('frameMirrored', () => {
    const systemModal = document.querySelector('#mirror-frame-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('bayCopied', () => {
    const systemModal = document.querySelector('#copy-bay-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('conCopied', () => {
    const systemModal = document.querySelector('#copy-con-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('flagCopied', () => {
    const systemModal = document.querySelector('#copy-flag-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('extraDeleted', () => {
    const systemModal = document.querySelector('#delete-extra-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('extraCopied', () => {
    const systemModal = document.querySelector('#copy-extra-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('glassCopied', () => {
    const systemModal = document.querySelector('#copy-glass-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('bayWindowDeleted', () => {
    const systemModal = document.querySelector('#delete-bay-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('flaggedFrameDeleted', () => {
    const systemModal = document.querySelector('#delete-flag-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('conservatoryDeleted', () => {
    const systemModal = document.querySelector('#delete-con-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('orderGlassUnitDeleted', () => {
    const systemModal = document.querySelector('#delete-glass-unit-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('installationTypeDeleted', () => {
    const systemModal = document.querySelector('#delete-installation-type-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('leadDebriefDeleted', () => {
    const systemModal = document.querySelector('#delete-lead-debrief-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});
Livewire.on('leadSourceDeleted', () => {
    const systemModal = document.querySelector('#delete-lead-source-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});


Livewire.on('mullionStyleDeleted', () => {
    const mullionStyleModal = document.querySelector('#delete-mullion-style-modal');
    const modal = bootstrap.Modal.getInstance(mullionStyleModal);    
    modal.toggle();
});

Livewire.on('transomStyleDeleted', () => {
    const transomStyleModal = document.querySelector('#delete-transom-style-modal');
    const modal = bootstrap.Modal.getInstance(transomStyleModal);    
    modal.toggle();
});

Livewire.on('paneStyleDeleted', () => {
    const paneStyleModal = document.querySelector('#delete-pane-style-modal');
    const modal = bootstrap.Modal.getInstance(paneStyleModal);    
    modal.toggle();
});

Livewire.on('sashStyleDeleted', () => {
    const sashStyleModal = document.querySelector('#delete-sash-style-modal');
    const modal = bootstrap.Modal.getInstance(sashStyleModal);    
    modal.toggle();
});

Livewire.on('glassPatternDeleted', () => {
    const systemModal = document.querySelector('#delete-glass-pane-pattern-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('updateManufacturerBackgroundColour', (background_colour) => {
    var sidebar = document.querySelector(".sidebar");
    sidebar.style.backgroundColor = background_colour;
});

Livewire.on('updateManufacturerImage', (image_url) => {
    var image = document.querySelector(".manufacturer-logo");
    image.src = image_url;
});


Livewire.on('subscriptionDowngraded', () => {
    const systemModal = document.querySelector('#downgrade-subscription-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('subscriptionDowngradeCancelled', () => {
    const systemModal = document.querySelector('#cancel-downgrade-subscription-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});

Livewire.on('subscriptionQuantityUpdated', () => {
    const systemModal = document.querySelector('#update-subscription-modal');
    const modal = bootstrap.Modal.getInstance(systemModal);    
    modal.toggle();
});



Livewire.on('updateManufacturerHighlightColour', (highlight_colour) => {
    var listItems = document.querySelectorAll(".sidebar li");
    var list_array = [...listItems];
    list_array.forEach(listItem => {
        listItem.addEventListener("mouseenter", function( event ) {   
          event.target.style.backgroundColor = highlight_colour;
        }, false);
        listItem.addEventListener("mouseleave", function( event ) {   
          event.target.style.backgroundColor = "";
        }, false);
    });
});

Livewire.on('updateManufacturerFontColour', (font_colour) => {
    var links = document.querySelectorAll(".sidebar a");
    var links_array = [...links];
    links_array.forEach(link => {
        link.style.color = font_colour;
    });
});

Livewire.on('setWYSIWYGField', content => {
    const domEditableElement = document.querySelector( '.ck-editor__editable' );
    if(domEditableElement)
    {
        const editorInstance = domEditableElement.ckeditorInstance;
        editorInstance.setData( content );
    }

});

var hash = location.hash.replace(/^#/, '');
if (hash) {
    var tabEl = document.querySelector('.nav-pills button[data-bs-target="#'+hash+'"]')
    var tab = new bootstrap.Tab(tabEl);
    tab.show();
}

document.addEventListener('DOMContentLoaded', (event) => {
    let activeLink = document.querySelector('.sidebar .active');
    if(activeLink)
    {
        activeLink.parentElement.classList.add("show");
    }
});

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});

